import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ElementRef, HostListener} from '@angular/core';
import {ColDef, ColGroupDef, GridOptions} from 'ag-grid-community';
import {HHGRateQueryRequest, HHGRateQueryResult, HhgQueryRequest} from 'src/app/shared/common-components/common-structure';
import AppConstants, {
  agency_auditor_role,
  carrier_user,
  carrier_user_admin,
  hhg_download_success
} from '../../shared/common-components/AppConstants';
import {User} from '../../services/user/user';
import {UserService} from '../../services/user/user.service';
import {AlertService} from '../../services/alert/alert.service';
import {LoadingService} from '../../services/loading/loading.service';
import * as _ from 'lodash';
import {HhgRateQueryService} from '../../services/hhg-rate-query/hhg-rate-query.service';
import {takeWhile} from 'rxjs/operators';
import {BehaviorSubject} from 'rxjs';
import {DownloadFileResponse} from 'src/app/shared/common-components/file-storage/downloadFileResponse';
import FileSaver from 'file-saver';
import {Router} from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { HhgUabCalculatorComponent } from '../hhg-uab-calculator/hhg-uab-calculator.component';
import { TspStatusPortalComponent } from '../tsp-status-portal/tsp-status-portal.component';
import moment from 'moment';


@Component({
    selector: 'app-hhg-rate-query-results',
    templateUrl: './hhg-rate-query-results.component.html',
    styleUrls: ['./hhg-rate-query-results.component.css'],
    standalone: false
})
export class HhgRateQueryResultsComponent implements OnInit, OnChanges, OnDestroy {

  hhgRateQueryResultsGridOptions: GridOptions = this.initializeGridOptions();
  @Input() hhgRateQueryResults: HHGRateQueryResult[];
  @Input() pickUpDate: any;
  @Input() moveDate: any;
  @Input() sroType: string;
  @Input() vehicleClass: any;
  @Input() sit: any;
  @Input() sitBreakdown: any;
  @Input() noOfDays: any;
  @Input() isInternational: any;
  @Input() isShownUAB: boolean;
  @Input() uabWeight: any;
  @Input() excelHeaderString: any;
  @Input() userPrefList: any;
  @Input() extendedStorage: Boolean = false;
  @Output() hhgRateQuerySelected = new EventEmitter<HHGRateQueryResult>();

  isMoveDateToday;
  private observer$ = new BehaviorSubject(true);
  private gridApi;
  private rowClassRules;
  columnDefs: any;
  public overlayNoRowsTemplate;
  currentUser: User | any;
  @Input() showComments;
  defaultExportParams: any = null;
  @Input() showBody = false;
  @Input() screenName: any;
  userPrefBtnText: any;
  private hhgRateQueryRequest: HHGRateQueryRequest;
  bsModalRef: BsModalRef;

  constructor(private userService: UserService, private alertService: AlertService, private loader: LoadingService,
              private hhgRateQueryService: HhgRateQueryService, private el: ElementRef, private modalService: BsModalService,
              private router: Router) {
    this.overlayNoRowsTemplate = '<span>No approved TSPs available for the selected query. Please adjust your query options.</span>';
  }

  /**
   * when @Input changes for sroType calling updateColumnDefs for updated columnDefs
   * @param: changes
   */
  ngOnChanges(changes: SimpleChanges): void {
    this.userPrefBtnText = 'Set data view preferences';
    // this.updateVehicleClassDef();
    this.updateColumnDefs();
    if (changes && AppConstants.isNotNullCondition(changes.sroType)) {
      if (changes.sroType.currentValue) {
        this.updateColumnDefs();
      }
    }
    if (changes && AppConstants.isNotNullCondition(changes.sit)) {
      if (changes.sit.currentValue) {
        this.updateColumnDefs();
      }
    }
    if (changes && AppConstants.isNotNullCondition(changes.sitBreakdown)) {
      if (changes.sitBreakdown.currentValue) {
        this.updateColumnDefs();
      }
    }
    if (changes && AppConstants.isNotNullCondition(changes.noOfDays)) {
      if (changes.noOfDays.currentValue) {
        this.updateColumnDefs();
      }
    }
    if (changes && AppConstants.isNotNullCondition(changes.isInternational)) {
      if (changes.isInternational.currentValue) {
        this.updateColumnDefs();
      }
    }
    if (changes && AppConstants.isNotNullCondition(changes.moveDate)) {
      if (new Date(this.moveDate.toDateString()) < new Date(new Date().toDateString())) {
        this.isMoveDateToday = false;
      } else {
        this.isMoveDateToday = true;
      }
      this.updateColumnDefs();
    }
    this.defaultExportParams = {
      customHeader: this.excelHeaderString
    };
  }

  ngOnInit() {
    this.loader.show();
    this.userService.getCurrentUserObservable()
      .pipe(takeWhile(() => this.observer$.value))
      .subscribe(currentUser => {
        this.currentUser = currentUser;
        this.loader.hide();
      }, error => {
        this.loader.hide();
        this.alertService.info('unable to get current user details');
      });
  }


  /**
   * updating columnDefs based on sroType Extended Storage, only Extended Storage had different results
   */
  updateColumnDefs() {
    this.columnDefs = this.getHHGRateQueryResultColumnDefs();
    if (this.sit === 'Destination' && this.sitBreakdown === 'Yes' && AppConstants.isNotNullCondition(this.noOfDays)) {
      const elementIndex = this.columnDefs.map(function (e) {
        return e?.headerName?.toUpperCase();
      }).indexOf('DLVY OVER 50 MILES');
      this.columnDefs.splice(elementIndex, 0, {
        field: 'totalDestinationSit', headerValueGetter: params => {
          return 'SIT Total ' + this.noOfDays + ' days';
        },
        valueGetter: params => {
          return this.formatNumberCellRenderer((parseFloat(params.data.sitDest185ACharge) + (parseFloat(params.data.sitDest185BCharge) * (parseFloat(this.noOfDays) - 1)) + parseFloat(params.data.sitDest210ACharge)).toFixed(2));
        },
        minWidth: 110,
        maxWidth: 120
      });
    } else if (this.sit === 'Origin' && this.sitBreakdown === 'Yes' && AppConstants.isNotNullCondition(this.noOfDays)) {
      const elementIndex1 = this.columnDefs.map(function (e) {
        return e.headerName.toUpperCase();
      }).indexOf('DLVY OVER 50 MILES');
      this.columnDefs.splice(elementIndex1, 0, {
        field: 'totalOriginSit', headerValueGetter: params => {
          return 'SIT Total ' + this.noOfDays + ' days';
        }, cellRenderer: params => {
          return this.formatNumberCellRenderer((parseFloat(params.data.sitOrigin185ACharge) + (parseFloat(params.data.sitOrigin185BCharge) * (parseFloat(this.noOfDays) - 1)) + parseFloat(params.data.sitOrigin210ACharge)).toFixed(2));
        },
        minWidth: 110,
        maxWidth: 120
      });
    }

    if(this.vehicleClass && this.vehicleClass !== null){
      const elementIndex1 = this.columnDefs.map(function (e) {
        return e?.headerName?.toUpperCase();
      }).indexOf('VEHICLE');
      const tooltip = 'Vehicle '+ this.vehicleClass;
      this.columnDefs.splice(elementIndex1, 1, {
        field: 'vehicleCharge',
        headerValueGetter: (params:any) => { return 'Vehicle '+ this.vehicleClass; },
        minWidth: 110,
        maxWidth: 120,
        valueFormatter: this.formatNumber,
        headerTooltip: tooltip,
      });
    }
    // resetting hide to false
    this.columnDefs.forEach(x => {
      x.hide = false;
    });
    if (this.sroType === 'Extended Storage') {
      this.columnDefs.forEach(x => {
        x.hide = x.field === 'csi' || x.field === 'vi' || x.field === 'surfacePercentage' || x.field === 'surfaceCharge'
          || x.field === 'uabPercentage' || x.field === 'uabCharge' || x.field === 'vehicleCharge' || x.field === 'totalCharge' || x.field === 'accrlRatePercentage'
          || x.field === 'thirtyDayCharge' || x.field === 'sixtyDayCharge' || x.field === 'ninetyDayCharge' || x.field === 'sitRatePercentage'
          || x.field === 'originThirtyDayCharge' || x.field === 'originSixtyDayCharge' || x.field === 'originNinetyDayCharge' || x.field === 'sitOrigin185ACharge'
          || x.field === 'sitOrigin185BCharge' || x.field === 'sitOrigin210ACharge' || x.field === 'sitDest185ACharge' || x.field === 'sitDest185BCharge'
          || x.field === 'sitDest210ACharge';
      });
    } else {
      if (this.sit === 'Destination') {
        // hide all origin related columns
        this.columnDefs.forEach(x => {
          x.hide = x.field.indexOf('exs') !== -1 || x.field === 'originThirtyDayCharge' || x.field === 'originSixtyDayCharge' || x.field === 'originNinetyDayCharge' || x.field === 'sitOrigin185ACharge'
            || x.field === 'sitOrigin185BCharge' || x.field === 'sitOrigin210ACharge';
        });
        if (this.isInternational) {
          // hide 185a, 185b and 210a for both origin and destination
          this.columnDefs.forEach(x => {
            x.hide = x.field.indexOf('exs') !== -1 || x.field === 'sitDest185ACharge' || x.field === 'sitDest185BCharge' || x.field === 'sitDest210ACharge'
              || x.field === 'sitOrigin185ACharge' || x.field === 'sitOrigin185BCharge' || x.field === 'sitOrigin210ACharge' ||
              x.field === 'originThirtyDayCharge' || x.field === 'originSixtyDayCharge' || x.field === 'originNinetyDayCharge';
          });
        }
        if (this.sitBreakdown === 'Yes' && !AppConstants.isNotNullCondition(this.noOfDays)) {
          //  hide total destination sit
          this.columnDefs.forEach(x => {
            x.hide = x.field === 'totalDestinationSit' || x.field.indexOf('exs') !== -1 || x.field === 'originThirtyDayCharge' || x.field === 'originSixtyDayCharge' || x.field === 'originNinetyDayCharge' || x.field === 'sitOrigin185ACharge'
              || x.field === 'sitOrigin185BCharge' || x.field === 'sitOrigin210ACharge';
          });
        }
        if (this.sitBreakdown === 'No') {
          // hide 185a, 185b and 210a and total destination sit
          this.columnDefs.forEach(x => {
            x.hide = x.field === 'sitDest185ACharge' || x.field === 'sitDest185BCharge' || x.field === 'sitDest210ACharge' || x.field === 'totalDestinationSit' ||
              x.field.indexOf('exs') !== -1 || x.field === 'originThirtyDayCharge' || x.field === 'originSixtyDayCharge' || x.field === 'originNinetyDayCharge' || x.field === 'sitOrigin185ACharge'
              || x.field === 'sitOrigin185BCharge' || x.field === 'sitOrigin210ACharge';
          });
        }
      }
      if (this.sit === 'Origin') {
        // hide all destination related columns
        this.columnDefs.forEach(x => {
          x.hide = x.field.indexOf('exs') !== -1 || x.field === 'thirtyDayCharge' || x.field === 'sixtyDayCharge' || x.field === 'ninetyDayCharge' || x.field === 'sitDest185ACharge'
            || x.field === 'sitDest185BCharge' || x.field === 'sitDest210ACharge';
        });
        if (this.isInternational) {
          // hide 185a, 185b and 210a for both origin and destination
          this.columnDefs.forEach(x => {
            x.hide = x.field.indexOf('exs') !== -1 || x.field === 'sitDest185ACharge' || x.field === 'sitDest185BCharge' || x.field === 'sitDest210ACharge'
              || x.field === 'sitOrigin185ACharge' || x.field === 'sitOrigin185BCharge' || x.field === 'sitOrigin210ACharge' ||
              x.field === 'thirtyDayCharge' || x.field === 'sixtyDayCharge' || x.field === 'ninetyDayCharge';
          });
        }
        if (this.sitBreakdown === 'Yes' && !AppConstants.isNotNullCondition(this.noOfDays)) {
          //  hide total origin sit
          this.columnDefs.forEach(x => {
            x.hide = x.field.indexOf('exs') !== -1 || x.field === 'thirtyDayCharge' || x.field === 'sixtyDayCharge' || x.field === 'ninetyDayCharge' || x.field === 'sitDest185ACharge'
              || x.field === 'sitDest185BCharge' || x.field === 'sitDest210ACharge' || x.field === 'totalOriginSit';
          });
        }
        if (this.sitBreakdown === 'No') {
          // hide 185a, 185b and 210a
          this.columnDefs.forEach(x => {
            x.hide = x.field.indexOf('exs') !== -1 || x.field === 'thirtyDayCharge' || x.field === 'sixtyDayCharge' || x.field === 'ninetyDayCharge' || x.field === 'sitDest185ACharge'
              || x.field === 'sitDest185BCharge' || x.field === 'sitDest210ACharge' || x.field === 'sitOrigin185ACharge' || x.field === 'sitOrigin185BCharge' || x.field === 'sitOrigin210ACharge' || x.field === 'totalOriginSit';
          });
        }
      }
      console.log(this.columnDefs);
    }

    if(this.isShownUAB && this.uabWeight !== null){
      const elementIndex = this.columnDefs.map(function (e) {
        return e.headerName.toUpperCase();
      }).indexOf('UAB CHARGE');
      const displayHeader = 'UAB Charge ' + this.uabWeight + ' lbs';
      this.columnDefs.splice(elementIndex, 1, {
        field: 'uabCharge',
        headerValueGetter: (params: any) => {
          return displayHeader;
        },
        headerTooltip: displayHeader,
        minWidth: 110,
        maxWidth: 120
      });
    }
    this.showHideColumnsBasedOnPrefs();
  }



  /**
   * initializing the grid
   */
  private initializeGridOptions() {
    return <GridOptions>{
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      headerHeight: 50,
      statusBar: {
        statusPanels: [
          {statusPanel: 'agTotalAndFilteredRowCountComponent'},
          {statusPanel: 'agTotalRowCountComponent', align: 'center'},
          {statusPanel: 'agFilteredRowCountComponent'},
          {statusPanel: 'agSelectedRowCountComponent'},
        ]
      },
      // pagination: true,
      // paginationPageSize: 25,
      // cacheBlockSize: 25,
      // domLayout: 'autoHeight',
      rowData: this.hhgRateQueryResults,
      suppressExcelExport: true,
      onGridReady: params => {
        this.gridApi = params.api;
        params.api.sizeColumnsToFit();
      },
      onRowDataChanged: params => {
        this.gridApi = params.api;
        params.api.sizeColumnsToFit();
      },
      rowClassRules: {
      //  'new-carrier': 'data.scac.indexOf("New") > -1 ',

        'new-carrier': function (params) {
          const sroTypeList = ['EXSTG', 'CCNTL', 'XSARC'];
          return params.data.scac.indexOf('New') > -1 && !sroTypeList.includes(params.data.sro) ;
        },
        'vi-100-less-carrier': function (params) {
          const sroTypeList = ['EXSTG', 'CCNTL', 'XSARC'];
          const viScore = params.data.vi;
          return viScore >= 0 && viScore <= 100 && params.data.scac.indexOf('New') <= -1 && !sroTypeList.includes(params.data.sro);
        },
        'vi-100-above-carrier': function (params) {
          const sroTypeList = ['EXSTG', 'CCNTL', 'XSARC'];
          const viScore = params.data.vi;
          return viScore > 100 && params.data.scac.indexOf('New') <= -1 && !sroTypeList.includes(params.data.sro);
        },
      },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
    };
  }

  getHHGRateQueryResultColumnDefs(): (ColDef | ColGroupDef)[] {
    return [
      <ColDef>
        {
          headerName: 'Rate Type',
          field: 'rateType',
          filter: 'agTextColumnFilter',
          minWidth: 80,
          maxWidth: 90,
          headerTooltip: 'Rate Type'
        },
      {
        headerName: 'SCAC',
        field: 'scac',
        filter: 'agTextColumnFilter',
        minWidth: 80,
        maxWidth: 120,
        headerTooltip: 'SCAC',
        cellRenderer: params => {
          if (AppConstants.isNotNullCondition(params) &&
            (!this.checkUserRole(carrier_user) &&
            !this.checkUserRole(carrier_user_admin) && !this.checkUserRole(carrier_user_admin) &&
            !this.checkUserRole(agency_auditor_role)) && this.sroType !== 'Extended Storage' &&
            (moment(moment(this.moveDate).format('MM-DD-YYYY')).
               diff(moment(moment().format('MM-DD-YYYY')),'days') >= 0))
          {
            return '<a tabindex="0">' + params.data.scac + '</a>';
          } else {
            return params.data.scac;
          }
        },
        onCellClicked: event => (!this.checkUserRole(carrier_user) &&
                                !this.checkUserRole(carrier_user_admin) &&
                                !this.checkUserRole(carrier_user_admin) &&
                                !this.checkUserRole(agency_auditor_role) &&
                                this.sroType !== 'Extended Storage' &&
                                (moment(moment(this.moveDate).format('MM-DD-YYYY')).
                                 diff(moment(moment().format('MM-DD-YYYY')),'days') >= 0)) ?
                                  this.onSCACClicked(event.data) : null
      },
      {
        headerName: 'Company',
        field: 'companyName',
        filter: 'agTextColumnFilter',
        minWidth: 160,
        maxWidth: 250,
        headerTooltip: 'Company',
      },
      {
        headerName: 'Phone',
        field: 'telephone',
        filter: 'agTextColumnFilter',
        minWidth: 160,
        maxWidth: 180,
        headerTooltip: 'Phone',
      },
      {
        headerName: 'Tender',
        field: 'tender',
        filter: 'agTextColumnFilter',
        minWidth: 90,
        maxWidth: 100,
        headerTooltip: 'Tender',
      },
      {
        headerName: 'Smartway',
        field: 'zefflag',
        filter: 'agTextColumnFilter',
        minWidth: 110,
        maxWidth: 120,
        headerTooltip: 'Smartway',
        cellStyle: {'text-align': 'center'},
        cellRenderer: params =>
          params.data.zefflag
            ? '<svg class="usa-icon define-text-green define-size-leaf" aria-hidden="true" focusable="false" role="img"><use xlink:href="/assets/uswds/img/sprite.svg#eco"></use></svg>'
            : ''
      },
      {
        headerName: 'Socio Econ Ind',
        field: 'socioEconomicInd',
        filter: 'agTextColumnFilter',
        minWidth: 80,
        maxWidth: 90,
        headerTooltip: 'Socio Econ Ind',
      },
      {
        headerName: 'CSI',
        field: 'csi',
        minWidth: 90,
        maxWidth: 100,
        headerTooltip: 'CSI',
      },
      {
        headerName: 'VI',
        field: 'vi',
        minWidth: 110,
        maxWidth: 120,
        headerTooltip: 'VI',
      },
      {
        headerName: 'Surface %',
        field: 'surfacePercentage',
        valueFormatter: this.percentageFormatter,
        minWidth: 110,
        maxWidth: 120,
        headerTooltip: 'Surface %',
      },
      {
        headerName: 'Surface Charge',
        field: 'surfaceCharge',
        valueFormatter: this.formatNumber,
        minWidth: 110,
        maxWidth: 120,
        headerTooltip: 'Surface Change',
      },
      {
        headerName: 'UAB %',
        field: 'uabPercentage',
        valueFormatter: this.percentageFormatter,
        minWidth: 80,
        maxWidth: 90,
        headerTooltip: 'UAB %',
      },
      {
        headerName: 'UAB Charge',
        field: 'uabCharge',
        valueFormatter: this.formatNumber,
        minWidth: 110,
        maxWidth: 120,
        headerTooltip: 'UAB Charge',
      },
      {
        headerName: 'Vehicle',
        field: 'vehicleCharge',
        valueFormatter: this.formatNumber,
        minWidth: 110,
        maxWidth: 120,
        headerTooltip: 'Vehicle',
      },
      {
        headerName: 'Total',
        field: 'totalCharge',
        valueFormatter: this.formatNumber,
        minWidth: 110,
        maxWidth: 120,
        headerTooltip: 'Total',
      },
      {
        headerName: 'Accrl %',
        field: 'accrlRatePercentage',
        valueFormatter: this.percentageFormatter,
        minWidth: 110,
        maxWidth: 120,
        headerTooltip: 'Accrl %',
      },
      {
        headerName: 'SIT %',
        field: 'sitRatePercentage',
        valueFormatter: this.percentageFormatter,
        minWidth: 80,
        maxWidth: 90,
        headerTooltip: 'SIT %',
      },
      {
        headerName: 'Dest 30 Days',
        field: 'thirtyDayCharge',
        valueFormatter: this.formatNumber,
        minWidth: 110,
        maxWidth: 120,
        headerTooltip: 'Dest 30 Days',
      },
      {
        headerName: 'Dest 60 Days',
        field: 'sixtyDayCharge',
        valueFormatter: this.formatNumber,
        minWidth: 110,
        maxWidth: 120,
        headerTooltip: 'Dest 60 Days',
      },
      {
        headerName: 'Dest 90 Days',
        field: 'ninetyDayCharge',
        valueFormatter: this.formatNumber,
        minWidth: 110,
        maxWidth: 120,
        headerTooltip: 'Dest 90 Days',
      },
      {
        headerName: 'Origin 30 Days',
        field: 'originThirtyDayCharge',
        valueFormatter: this.formatNumber,
        minWidth: 110,
        maxWidth: 120,
        headerTooltip: 'Origin 30 Days',
      },
      {
        headerName: 'Origin 60 Days',
        field: 'originSixtyDayCharge',
        valueFormatter: this.formatNumber,
        minWidth: 110,
        maxWidth: 120,
        headerTooltip: 'Origin 60 Days',
      },
      {
        headerName: 'Origin 90 Days',
        field: 'originNinetyDayCharge',
        valueFormatter: this.formatNumber,
        minWidth: 110,
        maxWidth: 120,
        headerTooltip: 'Origin 90 Days',
      },
      {
        headerName: 'Origin 1st Day',
        field: 'sitOrigin185ACharge',
        valueFormatter: this.formatNumber,
        minWidth: 110,
        maxWidth: 120,
        headerTooltip: 'Origin 1st Day',
      },
      {
        headerName: `Origin Each Add'l Day`,
        field: 'sitOrigin185BCharge',
        valueFormatter: this.formatNumber,
        minWidth: 110,
        maxWidth: 120,
        headerTooltip: 'Origin 1st Day',
      },
      {
        headerName: 'Origin Dlvy Out (Under 50 miles)',
        field: 'sitOrigin210ACharge',
        valueFormatter: this.formatNumber,
        minWidth: 110,
        maxWidth: 120,
        headerTooltip: 'Origin Dlvy Out (Under 50 miles)',
      },
      {
        headerName: 'Dest 1st Day',
        field: 'sitDest185ACharge',
        valueFormatter: this.formatNumber,
        minWidth: 110,
        maxWidth: 120,
        headerTooltip: 'Dest 1st Day',
      },
      {
        headerName: `Dest Each Add'l Day`,
        field: 'sitDest185BCharge',
        valueFormatter: this.formatNumber,
        minWidth: 110,
        maxWidth: 120,
        headerTooltip: `Dest Each Add'l Day`,
      },
      {
        headerName: 'Dest Dlvy Out (Under 50 miles)',
        field: 'sitDest210ACharge',
        valueFormatter: this.formatNumber,
        minWidth: 110,
        maxWidth: 120,
        headerTooltip: 'Dest Dlvy Out (Under 50 miles)',
      },
      /*{
        headerName: 'Total Destination SIT',
        colId: 'totalDestinationSit',
        valueGetter: function (params) {
          return params.data.sitDest185ACharge + (params.data.sitDest185BCharge * (this.noOfDays - 1)) + params.data.sitDest210ACharge;
        }
      },*/
      {
        headerName: 'Packaging Charge',
        field: 'exsPackagingCharge',
        valueFormatter: this.formatNumber,
        minWidth: 110,
        maxWidth: 120,
        headerTooltip: 'Packaging Charge',
      },
      {
        headerName: 'Monthly Storage Charge',
        field: 'exsMonthlyStorageCharge',
        valueFormatter: this.formatNumber,
        minWidth: 110,
        maxWidth: 120,
        headerTooltip: 'Monthly Storage Charge',
      },
      {
        headerName: 'Warehouse Charge',
        field: 'exsWarehouseCharge',
        valueFormatter: this.formatNumber,
        minWidth: 110,
        maxWidth: 120,
        headerTooltip: 'Warehouse Charge',
      },
      {
        headerName: 'Total 1 Month Charge',
        field: 'exsTotal1MonthCharge',
        valueFormatter: this.formatNumber,
        minWidth: 110,
        maxWidth: 120,
        headerTooltip: 'Total 1 Month Charge',
      },
      {
        headerName: 'Total 6 Month Charge',
        field: 'exsTotal6MonthCharge',
        valueFormatter: this.formatNumber,
        minWidth: 110,
        maxWidth: 120,
        headerTooltip: 'Total 6 Month Charge',
      },
      {
        headerName: 'Total 12 Month Charge',
        field: 'exsTotal12MonthCharge',
        valueFormatter: this.formatNumber,
        minWidth: 110,
        maxWidth: 120,
        headerTooltip: 'Total 12 Month Charge',
      },
      {
        headerName: 'Dlvy Within 50 Miles',
        field: 'exsDeliveryWithin50Miles',
        valueFormatter: this.formatNumber,
        minWidth: 110,
        maxWidth: 120,
        headerTooltip: 'Dlvy Within 50 Miles',
      },
      {
        headerName: 'Dlvy Handling Out',
        field: 'exsDeliveryHandlingOut',
        valueFormatter: this.formatNumber,
        minWidth: 110,
        maxWidth: 120,
        headerTooltip: 'Dlvy Handling Out',
      },

      {
        headerName: 'Dlvy Over 50 Miles',
        field: 'exsDeliveryOver50Miles',
        valueFormatter: this.formatNumberOto,
        minWidth: 110,
        maxWidth: 120,
        headerTooltip: 'Dlvy Over 50 Miles',
      },
/*
      {
        headerName: 'Dlvy Over 50 Miles',
        field: 'exsDeliveryOver50Miles',
       // valueFormatter: this.formatNumber,
        minWidth: 110,
        maxWidth: 120,
        headerTooltip: 'Dlvy Over 50 Miles',
        valueGetter: params => {
          if (params.data.exsDeliveryOver50Miles !== 'OTO') {
            return this.formatNumber(params.data.exsDeliveryOver50Miles);
          }
        },
      }, */

      {
        headerName: 'Shipment ID',
        field: 'sro',
        minWidth: 100,
        maxWidth: 110,
        headerTooltip: 'Shipment ID',
      }
    ];
  }

  onSCACClicked(hhgRateSelectedItem: HHGRateQueryResult) {
    this.hhgRateQuerySelected.emit(hhgRateSelectedItem);
  }

  /**
   *
   * @param: roles
   * @returns: {boolean}
   */
  checkUserRole(roles?) {
    if (this.currentUser) {
      const userRoles = _.map(this.currentUser.roles, x => x.role);
      if (userRoles && userRoles.length > 0) {
        return _.includes(userRoles, roles);
      }
    }
  }

  /**
   * @description: exports all the grid data from the datasource into a csv file using ag-grid api
   */
  onBtExport() {
    const date = new Date();
    const params = {
      fileName: 'hhg-query-results-report-' + date + '.csv',
      columnSeparator: ','
    };
    this.gridApi.exportDataAsCsv(params);
  }

  onFileDownload() {
    const request = JSON.parse(sessionStorage.getItem('queryRequest'));
    this.hhgRateQueryRequest = new HHGRateQueryRequest();
    const queryId = this.hhgRateQueryRequest.queryId;
    this.hhgRateQueryRequest.pickupDate = request.pickupDate;
    this.hhgRateQueryRequest.rateType = request.rateType;
    this.hhgRateQueryRequest.sroMasterId = request.sroMasterId;
    this.hhgRateQueryRequest.originCountryId = request.originCountryId;
    this.hhgRateQueryRequest.originZipId = request.originZipId;
    this.hhgRateQueryRequest.destinationCountryId = request.destinationCountryId;
    this.hhgRateQueryRequest.destinationZipId = request.destinationZipId;
    this.hhgRateQueryRequest.containerizedShipments = request.containerizedShipments;
    this.hhgRateQueryRequest.vehicleClass = request.vehicleClass;
    this.hhgRateQueryRequest.estimatedWeight = request.estimatedWeight;
    this.hhgRateQueryRequest.employeeFirstName = request.employeeFirstName;
    this.hhgRateQueryRequest.employeeMiddleName = request.employeeMiddleName;
    this.hhgRateQueryRequest.employeeLastName = request.employeeLastName;
    if (this.isInternational) {
      request.sitBreakDown = false;
      request.sitNoDays = 0;
    }
    this.hhgRateQueryRequest.sitLocation = request.sitLocation;
    this.hhgRateQueryRequest.sitBreakDown = request.sitBreakDown;
    this.hhgRateQueryRequest.sitNoDays = request.sitNoDays;
    this.hhgRateQueryRequest.miles = request.miles;
    this.hhgRateQueryRequest.uabWeight = request.uabWeight;
    this.hhgRateQueryRequest.userId = this.currentUser.id;
    this.hhgRateQueryRequest.orgId = this.currentUser.organizationId;
    this.hhgRateQueryRequest.screenName = this.screenName;
    if (this.hhgRateQueryRequest !== null) {
      this.loader.show();
      let hhgRateResult: DownloadFileResponse;
      this.hhgRateQueryService.downloadHHGRateResult(this.hhgRateQueryRequest).pipe(takeWhile(() => this.observer$.value)).subscribe(res => {
        hhgRateResult = res as DownloadFileResponse;
        const byteData: number[] = hhgRateResult.byteData;
        const fileName: string = hhgRateResult.fileName;
        const numRows: number = hhgRateResult.numberOfExcelRows;
        const bytes = new Uint8Array(byteData);
        const blob = new Blob([bytes], {
          type: null
        });
        FileSaver.saveAs(blob, fileName);
        this.alertService.success(hhg_download_success);
        this.loader.hide();
      }, error => {
        this.loader.hide();
        this.alertService.error('Error while getting the HHG Query Result downloaded');
      });
    } else {
      this.alertService.info('Please contact the system admin');
    }
  }

  gotoUserPrefs() {
    //this.screenName = 'HHGResults';
    this.showBody = true;

  }

  closeUserPrefs() {
    this.showBody = false;
  }

  /**
   * @description adds % symbol at the end of the value
   * @param params
   */
  percentageFormatter(params) {
    return params.value + '%';
  }

  /**
   * @description formats the value into comma seperator number (in thousands place) and adds $ sign to it.
   * @param params
   */
  formatNumber(params) {
    const number = params.value;
    if (AppConstants.isNotNullCondition(params.value)) {
      const parts = params.value.toString().split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return '$' + parts.join('.');
    } else {
      return '';
    }
  }

  formatNumberOto(params) {
    const number = params.value;
    if (AppConstants.isNotNullCondition(params.value) && params.data.exsDeliveryOver50Miles !== 'OTO') {
      const parts = params.value.toString().split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return '$' + parts.join('.');
    } else {
      return params.value; //
    }
  }

  formatNumberCellRenderer(value) {
    if (AppConstants.isNotNullCondition(value)) {
      const parts = value.toString().split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return '$' + parts.join('.');
    } else {
      return '';
    }
  }

  updateListPrefs(listPref: any) {
    this.userPrefList = listPref;
    this.updateColumnDefs();
  }

  showHideColumnsBasedOnPrefs() {
    if (this.userPrefList && this.userPrefList.length > 0) {
      this.columnDefs.forEach(col => {
        this.userPrefList.forEach(pref => {
          if ((pref.field === col.field) && (!pref.isVisible)) {
            col.hide = true;
          }
        });
      });
    }
  }

  @HostListener("window:beforeprint", ["$event"]) onBeforePrint() {
    var timer;
    const api = this.gridApi;
    modifytableBeforePrint();
    setPrinterFriendly(api);
    () =>{
      timer = setTimeout(() => {
        print();
        clearTimeout(timer);
      }, 2000);
    }
  }

  @HostListener("window:afterprint", ["$event"]) onAfterPrint() {
    const api = this.gridApi;
    setNormal(api);
  }

  onBtPrint() {
    const api = this.gridApi;
    setPrinterFriendly(api);
    setTimeout(function () {
      print();
      setNormal(api);
    }, 2000);
  }

  /**
   * destroying the subscription
   */
  ngOnDestroy(): void {
    this.observer$.next(false);
  }

  uabCalculator() {
    this.bsModalRef = this.modalService.show(HhgUabCalculatorComponent, {  class: 'modal-lg define-max-width',
    backdrop: 'static',
    keyboard: true,
    show: true});
    this.bsModalRef.content.closeBtnName = 'Close';
  }

  tspStatusPortal() {
    this.bsModalRef = this.modalService.show(TspStatusPortalComponent, {  class: 'modal-lg define-max-width',
    backdrop: 'static',
    keyboard: true,
    show: true});
    this.bsModalRef.content.closeBtnName = 'Close';
  }
}

function modifytableBeforePrint(){
  const eGridDiv = document.querySelector<HTMLElement>('#myGrid')! as any;
  if(AppConstants.isNotNullCondition(eGridDiv)){
    eGridDiv.style.height = '400px';
    eGridDiv.style.width = '1400px';
  }
}

function setPrinterFriendly(api) {
  const eGridDiv = document.querySelector<HTMLElement>('#myGrid')! as any;
  if(AppConstants.isNotNullCondition(eGridDiv)){
    eGridDiv.style.height = '';
    api.setDomLayout('print');
  }
}

function setNormal(api) {
  const eGridDiv = document.querySelector<HTMLElement>('#myGrid')! as any;
  if(AppConstants.isNotNullCondition(eGridDiv)){
    eGridDiv.style.width = '100%';
    eGridDiv.style.height = '400px';
    api.setDomLayout();
  }
}
